// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../../../../../services/api';
import { BASE_URL } from '../../../../../../../config/constants';

const orderDetailsService = async (data) => {
  return api(`/Sellitback.svc/GetOrderDetails/?CustomerId=${data.id}&Token=${data
    .token}&OrderID=${data.orderId}`, {}, 'GET');
};

const downloadExtraLabelService = (data) => {
  return (`${BASE_URL}/Sellitback.svc/GetOrderExtraLabel?CustomerID=${data
    .CustomerId}&Token=${data.Token}&OrderID=${data.OrderId}`);
};

const downloadWelcomePackService = (data) => {
  return (`${BASE_URL}/Sellitback.svc/GetOrderWelcomePack?CustomerID=${data
    .CustomerId}&Token=${data.Token}&OrderID=${data.OrderId}`);
};

export {
  orderDetailsService,
  downloadExtraLabelService,
  downloadWelcomePackService,
};
